import isElectron from 'is-electron';
import { lazy, Suspense, useEffect, useState } from 'react';
import { useMatch, redirect, Route, Routes } from 'router';

import { useEffectOnce } from 'hooks';
import { integrationInterceptor } from 'integrations';

import { MarketingDataProvider } from 'store/marketingDataContext';
import { readMetadata, useMetadataState } from 'store/metadata';

import { Error } from 'mosaiq/components';

import LoadingApp from 'components/LoadingApp/LoadingApp';

import { Login } from './views';

const OnboardingV2 = lazy(() => import('./views/OnboardingV2'));

const ComponentToRender = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>();

  useEffectOnce(() => {
    (async () => {
      try {
        const metadata = await readMetadata();
        setIsAuthenticated(metadata?.is_authenticated ?? false);
      } catch (_) {}
    })();
  });

  if (isAuthenticated === true) {
    return (
      <Suspense fallback={null}>
        <OnboardingV2 />
      </Suspense>
    );
  }

  if (isAuthenticated === false) {
    return <Login />;
  }

  return <LoadingApp />;
};

const UnauthedApp = () => {
  const [metadata] = useMetadataState<'unauthed'>();

  useEffect(() => {
    integrationInterceptor();
  }, []);

  useEffect(() => {
    if (['app', 'settings'].includes(metadata.render_page!) && !!metadata.is_authenticated) {
      window.location.href = `${window.location.protocol}//${metadata.host}`;
    }
  }, [metadata]);

  const match = useMatch('/login');

  if ((!metadata.person_id || metadata.is_invited || isElectron()) && !match) {
    redirect('/login');
  }

  return (
    <MarketingDataProvider>
      <Routes>
        <Route path="/login" element={<ComponentToRender />} />
        <Route path="/" element={<ComponentToRender />} />
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </MarketingDataProvider>
  );
};

export default UnauthedApp;
